export default "__VITE_ASSET__DftPmZQU__"